import React from "react";
// import { Link } from "react-router-dom";
// import useFetch from "../../../hooks/useFetch";
import LayoutInProgress from "../../layouts/LayoutInProgress";
// import GridPosts from "./GridPosts";

const Posts = () => {
	// const [posts] = useFetch("http://localhost:8080/blogs");
	// if (!posts.length > 0) return <LayoutInProgress />;
	const posts = [];
	console.log(posts);
	return <LayoutInProgress />;
	// return (
	// 	<section className="posts">
	// 		<div className="posts__hero">
	// 			<Link to={`/blogpost/${posts[0].id}`}>
	// 				<article>
	// 					<img src={posts[0].background} alt={posts[0].title} />
	// 					<h2>{posts[0].title.slice(0, 20).toUpperCase()}</h2>
	// 				</article>
	// 			</Link>
	// 		</div>

	// 		<GridPosts posts={posts} />
	// 	</section>
	// );
};

export default Posts;
